export const clerkAppearance = {
  variables: {
    colorPrimary: '#00467f',
    colorPrimaryForeground: '#ffffff',
    colorDanger: '#EF4444',
    colorSuccess: '#10B981',
    colorWarning: '#F59E0B',
    colorNeutral: '#6B7280',
    colorText: '#111827',
    colorTextSecondary: '#4B5563',
    colorBackground: '#ffffff',
    colorInputBackground: '#ffffff',
    colorInputText: '#111827',
    borderRadius: '0.375rem',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: '16px',
  },
  elements: {
    modalBackdrop: 'bg-black/50 backdrop-blur-sm',
    modalContent: 'rounded-xl shadow-xl border-0',
    card: 'rounded-xl shadow-none border-0',
    headerTitle: 'text-xl font-semibold text-gray-900',
    headerSubtitle: 'text-sm text-gray-600',
    formButtonPrimary:
      'bg-primary hover:bg-primary-dark text-white rounded-md min-h-[44px] shadow-none font-medium',
    formFieldInput:
      'border-gray-300 rounded-md text-gray-900 focus:border-primary focus:ring-2 focus:ring-primary',
    otpCodeFieldInput:
      'min-h-[44px] min-w-[44px] border-gray-300 rounded-md text-gray-900 focus:border-primary focus:ring-2 focus:ring-primary',
    footer: 'text-sm text-gray-500',
    footerActionLink: 'text-primary hover:text-primary-dark font-medium',
  },
};
